module.exports = __webpack_public_path__ + "static/media/high-fid-5.7dbc1b5f.svg";